@if (!item || item.isUploadedManually) {
    <app-loading-indicator />
} @else {
    @if (isStandard) {
        <app-report-standard [disableButtons]="disableButtons" (saveEmitter)="save($event)" />
    } @else {
        <app-report-released [disableButtons]="disableButtons" (saveEmitter)="save($event)" />
    }
}
